import * as caretakerServiceResponseManager from '$domain/model/caretaker/caretakerServiceResponse/caretakerServiceResponse.manager'

export const rejectService = (serviceId: string) => caretakerServiceResponseManager.caretakerRejectService(serviceId)



// WEBPACK FOOTER //
// ./src/services/caretaker/rejectService/rejectService.service.ts